export enum ConfigurationName {
    AuditEmail = 0,
    SmartStockCountsEnabled = 1,
    SmartStockCountInactivityDays = 2,
    SmartStockCountExcludeRemovedItemsDays = 3,
    CurrencyCode = 4,
    MaxToleranceWarningValue = 5,
    CreditRequestsEnabled = 6,
    OneClickReceiveEnabled = 7,
    AutoReceiveEnabled = 8,
    PurchaseOrderAdjustmentsEnabled = 9,
    SalesForecastEnabled = 10,
    CreditRequestEvidenceRequired = 11,
    DailyWasteCheckSheetEnabled = 12,
    RecipeAutoUpdates = 13,
    ItemAutoUpdates = 14,
    PosStoreNumberOverride = 15,
    MadeInStore = 16,
    PosIntegration = 17,
    COG = 18,
    ReturnToVendorEnabled = 19,
    AddItemsInPoEnabled = 20,
    TariffCodeEnabled = 21,
    ItemNumberPattern = 22,
    RecentActivityPeriod = 23,
    LocationsEnabled = 24,
    PaperPackagingDepletionEnabled = 25,
    RefundsBackToStockEnabled = 26,
    BIFeedsEnabled = 27,
    DisplayPoDetails = 28,
    PurchaseOrderReceivingLocalisation = 29,
    PurchaseOrdersDetailsDownload = 30,
    TimeZone = 31,
    CostPriceModel = 32,
    CupLidType = 33,
    BarcodeScanning = 34,
    ReceiptTransactionDate = 35,
    CountingInDifferentUoms = 36,
    SubLocalisationsEnabled = 37,
    TaxRatePercentage = 38,
    WacCutOffDate = 39,
    FranchiseDynamicBranding = 40,
    OracleSalesApiAuthenticationServer = 41,
    OracleSalesApiApplicationServer = 42,
    OracleSalesApiClientId = 43,
    OracleSalesApiUsername = 44,
    OracleSalesApiPassword = 45,
    OracleSalesApiOrgName = 46,
    OasisPassword = 47,
    OasisUserName = 48,
    OasisBaseUrl = 49,
    CountZonesWithItemsEnabled = 50,
    StockCountStrictEmailApproval = 51,
    ShiftConfigurationEnabled = 52,
    ShiftStartTime = 53,
    StockCountAutoApproval = 54,
    WasteLogUnitSupport = 55,
    AdHocReceiptCreationEnabled = 56,
    OrderPlanningV2Enabled = 57,
    PodPredictionReadonlyEnabled = 58,
    EmailFullReports = 59,
}